import { SubpageShell } from "@/components/layout/SubpageShell";
import { Services } from "@/components/landing/Services";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <SubpageShell titleZh="我们的服务" titleEn="Our Services">
        <Services />
      </SubpageShell>
    </div>
  );
}
